import { twMerge } from 'tailwind-merge';
import { ProductCardProps } from '../../types';

export default function CardBodyPreSale(props: Partial<ProductCardProps>) {
  const { data } = props;
  const { delivery_desc = '' } = data || {};

  if (!delivery_desc) {
    return null;
  }

  return (
    <div
      data-testid="wid-product-card-pre-sale-date"
      onClick={e => e.stopPropagation()}
      className={twMerge(
        'mb-1 min-w-0 max-w-full leading-4 enki-body-2xs-medium text-surface-100-fg-minor line-clamp-1'
      )}
      dangerouslySetInnerHTML={{ __html: delivery_desc }}
    />
  );
}
